import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 100,
	fill: "none",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "#fff",
		strokeLinecap: "round",
		strokeWidth: 3,
		d: "m78.58-2.75 6.19 5.33m6.19 5.32-6.2-5.32m0 0-.42 8.92m.43-8.92L76.7 4.7m8.07-2.13 1.75-7.7m-1.75 7.7L93.1.94M10.58 72.25l6.19 5.33m6.19 5.32-6.2-5.32m0 0-.42 8.92m.43-8.92L8.7 79.7m8.07-2.13 1.75-7.7m-1.75 7.7 8.34-1.64"
	})
});
const SvgTileBgSnow = styled(base)({});
export default SvgTileBgSnow;
